import axios from "axios";
import BaseCamApi from "./BaseCamApi";
import CamBanner from "../CamBanner";

export default class LiveJasminApi extends BaseCamApi {
    constructor(config) {
        super('LiveJasmin', config);

        this.feedUrl = config.liveJasmin.feedUrl;
        this.autoLoginUrl = config.autoLoginUrl;
    }

    /**
     * @param {string} gender
     * @returns {Promise<object[]>}
     */
    async loadRawBanners(gender) {
        const url = new URL(this.feedUrl);
        url.searchParams.set('gender', gender);

        try {
            const response = await axios.get(url.toString());
            return response.data || [];
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    /**
     * @param {object} rawBanner
     * @returns {CamBanner}
     */
    makeCamBanner(rawBanner) {
        const url = this.autoLoginUrl ? this.autoLoginUrl.replace(encodeURIComponent('{target}'), encodeURIComponent(rawBanner.chatRoomUrl)) : rawBanner.chatRoomUrl;

        return new CamBanner(
            rawBanner.performerId,
            rawBanner.displayName,
            rawBanner.details.willingnesses[0],
            Object.values(rawBanner.profilePictureUrl)[0],
            zone => url,
        );
    }
};
